// extracted by mini-css-extract-plugin
export default {"marquee":"Marquee_marquee__zti0I","marqueeContent":"Marquee_marqueeContent__vRqX0","infiniteScroll":"Marquee_infiniteScroll__V69c9"};